import React from 'react';

const initialState = {
  services: {
    ads: [],
    medicalServices: [],
    filesWithPrices: [],
    filesWithServiceDescription: []
  },
  service: {
    products: []
  },
  schedule: {
    doctors: []
  },
  administration: {
    workers: []
  },
  aboutUs: {
    contacts: []
  },
  requisites: { content: "" },
  paymentMethods: { content: "" },
  footer: {
    contacts: []
  }
};

const StoreContext = React.createContext();

function storeReducer(state, action) {
  switch (action.type) {
    case 'replace':
      return action.payload;
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function StoreProvider({ children }) {
  const [state, dispatch] = React.useReducer(storeReducer, initialState);
  const value = { state, dispatch };
  React.useEffect(() => {
    fetch(`/files/store.json`)
      .then(response => response.json())
      .then(data => {
        dispatch({
          type: 'replace',
          payload: data
        })
      })
      .catch(error => console.log(error));
  }, []);

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
}

function useStore() {
  const context = React.useContext(StoreContext);
  if (context === undefined) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
}

export { StoreProvider, useStore };
